module.exports = __webpack_public_path__ + "static/media/PowerInspect.4b1dd65f.png";